(ns web3.fuzzy-search
  (:require [clojure.string :as str]
            [cljs.reader :refer [read-string]]
            [web3.log :as log]
            ["fuse.js" :as Fuse]
            [web3.utils :as u]))

(def ^:private read-key (memoize read-string))

(defn clean-str [s]
  (when s (str/replace s #"[^0-9a-zA-Z ]+" "")))

(defn- make-search-fn-factory [search-attrs threshold]
  (fn [options]
    (let [options (into-array options)
          fuse (Fuse. options #js {:keys (into-array (mapv pr-str search-attrs))
                                   :getFn (fn [obj path]
                                            (u/get* obj (read-key path)))
                                   :threshold threshold})]
      (fn [val max-results]
        (try
          (js->clj (take max-results
                         (.search fuse (clean-str val)))
                   :keywordize-keys true)
          (catch :default e
            (log/warn "error invoking Fuse search:: " e)
            []))))))

(defn make-fuzzy-search-fn [search-attrs threshold]
  (let [make-search-fn (make-search-fn-factory search-attrs threshold)]
    (fn get-suggestions [value options max-results]
      (let [trimmed-value (if (string? value) (str/trim value) "")
            result (if (empty? trimmed-value)
                     (vec (take max-results options)) ;; TODO: honor an argument here to return ALL results or empty...
                     (vec ((make-search-fn options) trimmed-value max-results)))]
        result))))